import { useDroppable } from '@dnd-kit/core';
import { Col, Row } from 'antd';
import * as React from 'react';
import styled from 'styled-components';
import { RichTextAdvancedRender } from '../../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender';
import { Widget, WidgetType } from '../../../../Widget';
import { ITableCell, TableCellType } from '../ITableCell';
import { TableCellDraggable } from './TableCellDraggable';

export interface ITableColumnCellDroppableProps {
  column: Widget;
  placedCell?: ITableCell;
  handleAdd?: (selectedType: WidgetType) => void;
  handleEdit?: (e: any) => void;
  handleRemove?: (e: any) => void;
}

const $DroppableArea = styled.div<{ isOver: boolean }>`
  background-color: ${props => props.theme.colorBgContainer};
  border-radius: 8px;
  border: 2px dashed ${props => props.theme.colorBorderSecondary};
  padding: 12px 16px;
  text-align: center;
  margin-bottom: 8px;
  transition: border-color 0.2s ease-in-out;

  ${props => props.isOver && `border-color: ${props.theme.colorPrimary};`}
`;

/**
 * Permette di "assegnare" un widget ad una cella di una riga di custom,
 * in corrispondenza di una colonna definita nella tabella.
 */
export function TableColumnCellDroppable(
  props: ITableColumnCellDroppableProps,
) {
  const { column, placedCell } = props;
  const { setNodeRef, isOver } = useDroppable({
    id: column.id,
    data: {
      column,
    },
  });

  return (
    <div ref={setNodeRef}>
      <$DroppableArea isOver={isOver}>
        <Row>
          <Col span={8}>
            {'label' in column ? (
              <RichTextAdvancedRender text={column.label} />
            ) : null}
          </Col>
          <Col span={16}>
            {placedCell && placedCell.type === TableCellType.Widget && (
              <TableCellDraggable
                cell={placedCell}
                handleEdit={props.handleEdit}
                handleRemove={props.handleRemove}
              />
            )}
          </Col>
          {/* {!placedCell && (
            <WidgetSelect
              width="30%"
              onChange={selecedType => {
                props.handleAdd?.(selecedType);
              }}
            />
          )} */}
        </Row>
      </$DroppableArea>
    </div>
  );
}
